var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"app-main"},[_c('app-sidebar'),_c('el-container',{staticClass:"app-content",attrs:{"direction":"vertical"}},[_c('app-header'),_c('el-main',{staticClass:"app-center"},[_c('breadcrumb'),_c('keep-alive',{attrs:{"include":_vm.includes}},[_c('router-view',{attrs:{"to":_vm.$route.path}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }